import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './values.scss'
import fondo from '../../../media/img/companyInfo/fondovalues.png'

const Values = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    const valuesList = [
        { titleKey: "about.values.v1Title", descKey: "about.values.v1Desc" },
        { titleKey: "about.values.v2Title", descKey: "about.values.v2Desc" },
        { titleKey: "about.values.v3Title", descKey: "about.values.v3Desc" },
        { titleKey: "about.values.v4Title", descKey: "about.values.v4Desc" },
        { titleKey: "about.values.v5Title", descKey: "about.values.v5Desc" },
        { titleKey: "about.values.v6Title", descKey: "about.values.v6Desc" },
        { titleKey: "about.values.v7Title", descKey: "about.values.v7Desc" },
    ];

    return (
        <div className='values-company'>
            <div className='values-company__mainContainer'>
                <div className='values-company__section'>
                    <h2 className='content__title-backgroundDark'>{t('about.values.title')}</h2>
                    <div ref={el => lineRefs.current[0] = el} className="content__title-line" />
                    <h3 className='content__text-title-backgroundDark'>
                        {t('about.values.subtitle')}
                    </h3>
                </div>

                <div className='values-company__section'>
                    {valuesList.map((val, idx) => (
                        <div key={idx} className='values-company__values'>
                            <p className='content__text-paragrah-title-backgroundDark'>{t(val.titleKey)}</p>
                            <p className='content__text-paragrah-backgroundDark'>
                                {t(val.descKey)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
            <div className='values-company__background-image-container'>
                <img src={fondo} className='values-company__background-image' alt="" />
            </div>

        </div>
    )
}

export default Values